<div class="app-page" style="width: 100%;">
    <div style="display: flex; justify-content: center;min-height: 400px;"  [ngStyle]="{'background-image': 'url(' + this._globals.TeamImage + ')', 'background-repeat': 'no-repeat', 'background-position':'center' }">
    
       
    </div>

</div>
 